import PropTypes from 'prop-types'
import { XIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const RowActions = ({ isCheckInDisabled, onCheckInClick, isDeleteDisabled, onDeleteClick }) => {
  const { t } = useTranslation(['attendees'])

  return (
    <div className="actions">
      <button
        className="button button-transparent"
        onClick={onCheckInClick}
        disabled={isCheckInDisabled}
      >
        {t('attendees:rowActions.checkIn')}
      </button>
      <button
        className="button button-transparent"
        onClick={onDeleteClick}
        disabled={isDeleteDisabled}
      >
        <XIcon />
      </button>
    </div>
  )
}

RowActions.propTypes = {
  isCheckInDisabled: PropTypes.bool,
  onCheckInClick: PropTypes.func,
  isDeleteDisabled: PropTypes.bool,
  onDeleteClick: PropTypes.func,
}

export default RowActions
